<template>
  <div id="login">
    <form @submit.prevent="auth">
      <h3>LOGIN</h3>
      <input type="email" v-model="login.email"/>
      <input type="password" v-model="login.password"/>
      <button type="submit" :disabled="btnDisabled">Login</button>
    </form>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'login',
    data () {
      return {
        login: {},
        btnDisabled: false
      }
    },
    methods: {
      auth () {
        this.btnDisabled = true
        axios
          .post('http://dashboard.restoku.id/login/authVue', this.login)
          .then((r) => {
            if (r.data.failed) {
              alert('Login Gagal')
              this.btnDisabled = false
            } else {
              localStorage.setItem('id_toko', r.data.id)
              localStorage.setItem('nama_toko', r.data.nama)
              this.$router.push('/')
            }
          })
          .catch((e) => {
            this.btnDisabled = false
          })
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import url('https://fonts.googleapis.com/css2?family=Karla:wght@400;700&display=swap');

  * {
    font-family: 'Karla', sans-serif;
  }

  body {
    margin: 0;
    background: #f7f7f7;
  }

  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }

  form {
    width: 400px;
    margin: auto;
    margin-top: 100px;
    background: #fff;
    padding: 25px 30px;
    box-shadow: 0px 3px 3px #ccc;

    h3 {
      margin: 0;
      margin-bottom: 15px;
      text-align: center;
    }

    input {
      border: 1px solid #ccc;
      outline: none;
      padding: 15px;
      width: calc(100% - 30px);
      margin-bottom: 15px;
      transition: .3s all ease;

      &:focus {
        border-color: #168BE3;
      }
    }

    button {
      text-transform: uppercase;
      outline: none;
      background: #168BE3;
      color: #fff;
      width: 100%;
      border: 0;
      padding: 15px;

      &:disabled {
        background: #a1d2f7;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Login.vue